/* eslint-disable import/no-anonymous-default-export */
import { useEffect } from "react";
import { asrListInitial } from "services/asr.service";
import { useDispatch } from "react-redux";
import { setASRData } from "store/slice/search.slice";

export default () => {
  const dispatch = useDispatch();
  useEffect(() => {
    asrListInitial()
      .then((response: any) => {
        dispatch(
          setASRData({
            asrList: response?.data,
            latitude: response?.latitude,
            longitude: response?.longitude,
          })
        );
      })
      .catch((response: any) => console.log(response));
  }, []);
};
